// extracted by mini-css-extract-plugin
export default {"placeholder":"Placeholder_placeholder__+v7s5","glow":"Placeholder_glow__hIlzQ","placeholder-glow":"Placeholder_placeholder-glow__rQSpW","inline":"Placeholder_inline__ziHdp"};